import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { ShowCreateNewList } from '../actions/lists.actions';
import { CloseSidenav, OpenListsSidenav, ShowCampaignExecutions, ShowPreviewList } from '../actions/sidenav.actions';

export interface SidenavState {
  sidenavStatus: boolean;
  showPreviewList: boolean;
  showCreateNewList: boolean;
  showCampaignExecutions: boolean;
}

const initialState: SidenavState = {
  sidenavStatus: false,
  showPreviewList: false,
  showCreateNewList: false,
  showCampaignExecutions: false
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenListsSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
    showPreviewList: false,
    showCreateNewList: false,
    showCampaignExecutions: false
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    sidenavStatus: false,
    showPreviewList: false,
    showCreateNewList: false,
    showCampaignExecutions: false
  })),
  on(ShowPreviewList, (state) => ({
    ...state,
    showPreviewList: true,
    sidenavStatus: true,
  })),
  on(ShowCreateNewList, (state) => ({
    ...state,
    showCreateNewList: true,
    sidenavStatus: true,
  })),
  on(ShowCampaignExecutions, (state) => ({
    ...state,
    showCampaignExecutions: true,
    sidenavStatus: true,
  })),
);
